import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InstallmentConfigurationInitFormResponseModel } from "../model/InstallmentConfigurationInitFormResponseModel";
import { InstallmentConfigurationLotteryInitFormResponseModel } from "../model/InstallmentConfigurationLotteryInitFormResponseModel";
import { InstallmentConfigurationSchemeInitFormResponseModel } from "../model/InstallmentConfigurationSchemeInitFormResponseModel";
import { LotteryInstallmentConfigurationModel } from "../model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "../model/SchemeInstallmentConfigurationModel";
import { ExtendAcceptanceInitFormResponseModel } from "../model/ExtendAcceptanceInitFormResponseModel";
import { Page } from "../model/Page";
import { TenementModal } from "../model/TenementModal";
import { Observable } from "rxjs";
import { ExtendSurrenderInitFormResponseModel } from "../model/ExtendSurrenderInitFormResponseModel";

@Injectable({
  providedIn: "root",
})
export class ExtendSurrenderService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  initExtendSurrenderForm() {
    return this.httpClient.get<ExtendSurrenderInitFormResponseModel>(
      ApiUrls.extendSurrenderInitFormUrl
    );
  }

  initWithLottery(lotteryKey: number) {
    return this.httpClient.get<ExtendSurrenderInitFormResponseModel>(
      ApiUrls.extendSurrenderInitWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );

  }


  getLotteryandSchemeData(page: number, size: number,lotteryKey: number,schemeKey:number,drawStatus:string, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : `&filterText=${null}`)+`&lotteryKey=${lotteryKey}&schemeKey=${schemeKey}&drawStatus=${drawStatus}`;
    return this.httpClient.get<Page<TenementModal>>(
      ApiUrls.getLotteryandSchemeDataForSurrender +reqParams
    );
  }

  updateSurrenderDtl(payload: TenementModal,otpValue: any): Observable<object> {
    return this.httpClient.post<TenementModal>(
      `${ApiUrls.updateSurrenderDtl}?otpValue=${otpValue}`,
      payload
    );
  }

  viewWithLottery(lotteryKey: number, installmentType: string) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithLotteryUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  viewWithScheme(
    lotteryKey: number,
    schemeKey: number,
    installmentType: string
  ) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  
  initWithScheme(lotteryKey: number, schemeKey: number) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
    );
  }

  

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
  generateOtp(): Observable<object> {
    return this.httpClient.post<Object>(ApiUrls.generateOtpforSurrender,null);
  }
}
